import type { Model } from '@patsnap/tahiti-core/common/model';
import type { Permission } from '../types';

export const PermissionModel = Symbol.for('PermissionModel');

export interface PermissionModel extends Model<Permission> {}
